module.exports = __webpack_public_path__ + "static/media/mascot_recyclebin.fd0aaf8e.png";